import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { useLandingViewerRole } from '../../LandingPage/LandingPageCta';
import { getSearchType } from '../SearchPage.shared';

import css from './NoSearchResultsMaybe.module.css';

// Task-creation contract: /l/draft/00000000-0000-0000-0000-000000000000/new/details?type=tasks
const CREATE_TASK_PARAMS = {
  slug: 'draft',
  id: '00000000-0000-0000-0000-000000000000',
  type: 'new',
  tab: 'details',
};

// The empty message names what was searched, by the same search type as the page h1 (D20, D25):
// tasks only, services only, or both (the hero and topbar search have no type filter, T18).
const NO_RESULTS_MESSAGE_IDS = {
  tasks: 'SearchPage.noResultsTasks',
  services: 'SearchPage.noResults',
  all: 'SearchPage.noResultsAll',
};

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  // Listing type from the path (/s/:listingType) or the query (?pub_listingType=…).
  const listingTypePathParam = (location.pathname || '').match(/^\/s\/([^/]+)\/?$/)?.[1];
  const searchType = getSearchType(listingTypePathParam, {
    pub_listingType: new URLSearchParams(location.search || '').get('pub_listingType'),
  });
  // The create action follows the viewer's role (T16, D28; the same role source as the landing):
  // a provider creates a service, everyone else (client, guest, unresolved role) a task — a client
  // is never offered to create a service.
  const isProvider = useLandingViewerRole() === 'provider';

  // A provider who found no tasks gets a line that ties «Создать услугу» to the empty task search
  // (T18): the link and its target are unchanged; the line belongs to the link, not to the reset.
  const showCreateServiceLead = showCreateListingsLink && isProvider && searchType === 'tasks';

  const createListingLinkMaybe = !showCreateListingsLink ? null : isProvider ? (
    <NamedLink className={css.createListingLink} name="NewListingPage">
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : (
    <NamedLink
      className={css.createListingLink}
      name="EditListingPage"
      params={CREATE_TASK_PARAMS}
      to={{ search: '?type=tasks' }}
    >
      <FormattedMessage id="SearchPage.createTask" />
    </NamedLink>
  );

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <FormattedMessage id={NO_RESULTS_MESSAGE_IDS[searchType]} />
      <br />
      {hasSearchParams ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          <FormattedMessage id={'SearchPage.resetAllFilters'} />
        </button>
      ) : null}
      {showCreateServiceLead ? (
        <div className={css.createServiceBlock}>
          <p className={css.createServiceLead}>
            <FormattedMessage id="SearchPage.createServiceAfterTaskSearch" />
          </p>
          {createListingLinkMaybe}
        </div>
      ) : (
        <p>{createListingLinkMaybe}</p>
      )}
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
